import { render } from "./SearchPrevious.vue?vue&type=template&id=43a27d50"
import script from "./SearchPrevious.vue?vue&type=script&lang=js"
export * from "./SearchPrevious.vue?vue&type=script&lang=js"
script.render = render

export default script